import { isInternalHostname, normalizeHost } from 'libs/utils/url'

import { MapHostnameToSasSiteId, SMART_ADSERVER_NETWORK_ID } from 'constants/ads'

export function getSmartAdServerSiteId(host: string) {
  const normalizedHostname = normalizeHost(host)

  if (!isInternalHostname(normalizedHostname)) return null

  return MapHostnameToSasSiteId[normalizedHostname]
}

export function initSmartAdServer(smartAdServerSiteId: string, smartAdServerPageId: string) {
  window.sas = window.sas || {}
  window.sas.cmd = window.sas.cmd || []

  window.sas.cmd.push(() => {
    window.sas.setup({
      networkid: SMART_ADSERVER_NETWORK_ID,
      domain: '//www8.smartadserver.com',
      async: true,
      renderMode: 2,
    })
  })

  window.sas.adCallConfig = {
    siteId: smartAdServerSiteId,
    pageId: smartAdServerPageId,
    target: '',
    formats: [],
  }

  window.sas.callSmart = () => {
    window.sas.cmd.push(() => {
      window.sas.call('onecall', window.sas.adCallConfig)
    })

    window.sas.render()
  }
}
